import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;
  items: any[] = [];
  token: any;

  item = {
    name: null,
    description: null,
    price: 0,
    discount: 0
  }
  new_item = {
    name: null,
    description: null,
    price: 0,
    discount: 0
  }

  update_key: any;
  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal, private titleService: Title) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Admin Settings');

    this.getServices();
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, item: any) {
    this.update_key = item.id;
    this.new_item = item;

    this.modalService.open(content);
  }

  async getServices() {
    this.api.get('services/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects;
        this.list_length = this.items.length;
      },
      async error => { }
    );
  }

  async OnSubmit() {
    let body = { 
      'name': this.item.name, 
      'description': this.item.description,
      'price': this.item.price, 
      'discount': this.item.discount
     }

    this.api.post("services/", body, this.token).subscribe(
      async data => {
        this.getServices();
        Swal.fire({
          title: 'Success!',
          text: 'Added Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async OnUpdate(key: any) {
    let body = { 
      'name': this.new_item.name, 
      'description': this.new_item.description, 
      'price': this.new_item.price, 
      'discount': this.new_item.discount 
    }

    this.api.update("services/" + key, body, this.token).subscribe(
      async data => {
        this.getServices();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async onDelete(key: any) {
    if (confirm("Delete this item?")) {
      this.api.delete('services/' + key, this.token).subscribe(
        async data => {
          this.getServices();
          Swal.fire({
            title: 'Success!',
            text: 'Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }
}
